import { render, staticRenderFns } from "./UpdateRoom.vue?vue&type=template&id=067e82ba&scoped=true&"
import script from "./UpdateRoom.vue?vue&type=script&lang=js&"
export * from "./UpdateRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e82ba",
  null
  
)

export default component.exports